import React, { ChangeEvent, Dispatch, SetStateAction } from 'react'
import { Input, InputGroup, InputLeftAddon } from '@chakra-ui/react'

import { Search } from 'components/icons'

type Props = {
  search: string
  setSearch: Dispatch<SetStateAction<string>>
}

const AutoCompleteSearch = ({ search, setSearch }: Props) => {
  const handleOnChangeInput = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value
    setSearch(value)
  }

  return (
    <InputGroup>
      <InputLeftAddon bg="bgContent">
        <Search />
      </InputLeftAddon>
      <Input
        autoFocus
        rounded="none"
        border="none"
        outline="none"
        variant="ghost"
        placeholder="Pesquise os items..."
        value={search}
        onChange={handleOnChangeInput}
      />
    </InputGroup>
  )
}

export default AutoCompleteSearch
